import React, {useState} from 'react';
import {connect} from 'react-redux';
import {DropdownItem, DropdownMenu, DropdownToggle, Input, Nav, Dropdown} from 'reactstrap';
import {faAngleDown,} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useTranslation} from "react-i18next";

import {shopsRequestStart, shopsSelectShop} from "../../../actions/Shops";
import {setEnableMobileMenuSmall} from '../../../actions/ThemeOptions'
import bg3 from '../../../assets/utils/images/dropdown-header/abstract3.jpg';
import cookies from 'js-cookie'
import {LANGUAGES_WHITE_LIST, FALLBACK_LANG} from "../../../../src/constants";
import i18next from 'i18next'


const LanguageSelect = (
    {}
) => {
    const {t, i18n} = useTranslation();
    const languagesWhitelist = LANGUAGES_WHITE_LIST;
    const currentLanguageCode = i18n.language || FALLBACK_LANG;

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState();

    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const selectLang = (lang) => {
        i18next.changeLanguage(lang)
    };


    let dropdownShopItems = languagesWhitelist.map((lang) => {
        return <DropdownItem
            key={lang} active={lang === currentLanguageCode}
            onClick={() => selectLang(lang)}
        >
            {lang}
        </DropdownItem>
    });

    return <>
        <Nav className="header-megamenu">
            <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle nav>
                    {currentLanguageCode}
                    <FontAwesomeIcon className="ml-2 opacity-5" icon={faAngleDown}/>
                </DropdownToggle>
                <DropdownMenu
                    className="dropdown-menu-rounded dropdown-menu-lg rm-pointers"
                    modifiers={{
                        setMaxHeight: {
                            enabled: true,
                            fn: (data) => {
                                let w = window,
                                    d = document,
                                    e = d.documentElement,
                                    g = d.getElementsByTagName('body')[0],
                                    y = w.innerHeight || e.clientHeight || g.clientHeight;
                                return {
                                    ...data,
                                    styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: y - 50,
                                    },
                                };
                            },
                        },
                    }}
                >
                    <div className="dropdown-menu-header">
                        <div className="dropdown-menu-header-inner bg-success">
                            <div className="menu-header-image opacity-1"
                                 style={{
                                     backgroundImage: 'url(' + bg3 + ')'
                                 }}
                            ></div>
                            <div className="menu-header-content text-left">
                                <h5 className="menu-header-title">
                                    {t('layout.header.lang_menu.title', 'Choose your language')}
                                </h5>

                            </div>
                        </div>
                    </div>


                    {dropdownShopItems}
                </DropdownMenu>
            </Dropdown>
        </Nav>
    </>;
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    shopsRequestStart: (search, setIsSendingRequest) => dispatch(shopsRequestStart(search, setIsSendingRequest)),
    shopsSelectShop: shop => dispatch(shopsSelectShop(shop)),
    setEnableMobileMenuSmall: enabled => dispatch(setEnableMobileMenuSmall(enabled)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
